export default {
  fromValue (val) {
    switch (val) {
      case 'product':
        return 'Produto'
      case 'service':
        return 'Serviço'
      default:
        return val
    }
  }
}
